module.exports = __webpack_public_path__ + "img/invite.067f7303.png";